/**
 * Consentimento de cookies (LGPD).
 *
 * A escolha fica no `localStorage` deste dispositivo. Cookies de sessão
 * (`HttpOnly`) continuam necessários para autenticar a equipe — o banner não
 * bloqueia o calendário nem o login.
 */

export const COOKIE_CONSENT_KEY = "dream-cookie-consent";
export const COOKIE_CONSENT_VERSION = 1;

export type CookieConsentChoice = "accepted" | "necessary";

export interface CookieConsentRecord {
  choice: CookieConsentChoice;
  version: number;
  decidedAt: string;
}

export function parseCookieConsent(raw: string | null | undefined): CookieConsentRecord | null {
  if (raw === null || raw === undefined || raw.trim() === "") return null;
  try {
    const parsed = JSON.parse(raw) as Partial<CookieConsentRecord>;
    if (parsed.choice !== "accepted" && parsed.choice !== "necessary") return null;
    if (parsed.version !== COOKIE_CONSENT_VERSION) return null;
    if (typeof parsed.decidedAt !== "string" || parsed.decidedAt === "") return null;
    return {
      choice: parsed.choice,
      version: parsed.version,
      decidedAt: parsed.decidedAt,
    };
  } catch {
    return null;
  }
}

export function makeCookieConsent(
  choice: CookieConsentChoice,
  at: Date = new Date(),
): CookieConsentRecord {
  return {
    choice,
    version: COOKIE_CONSENT_VERSION,
    decidedAt: at.toISOString(),
  };
}

export function readCookieConsent(): CookieConsentRecord | null {
  try {
    return parseCookieConsent(localStorage.getItem(COOKIE_CONSENT_KEY));
  } catch {
    return null;
  }
}

export function writeCookieConsent(record: CookieConsentRecord): void {
  try {
    localStorage.setItem(COOKIE_CONSENT_KEY, JSON.stringify(record));
  } catch {
    // Storage bloqueado: a escolha vale só nesta sessão, em memória.
  }
}
